<template>
  <div class="wrapper" id="chartPage">
    <div class="actBar" v-if="ifPrint">
      <el-form :inline="true">
        <el-form-item>
          <el-select
            v-model="examinationId"
            size="small"
            placeholder="搜索考试名称"
          >
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input v-model="idCard" size="small" placeholder="考生身份证号">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
          <!-- <el-button
            type="primary"
            size="small"
            @click="printPage"
            v-if="areaPrintReady && normalPrintReady"
            >下载</el-button
          > -->
          <el-button type="primary" size="small" @click="downloadModel"
            >下载能力图谱模板</el-button
          >
          &emsp;
          <el-upload
            style="display: inline-block"
            action="/base/common/importPersonalAbilityMap"
            :headers="{ Authorization: getStore('accessToken') }"
            :show-file-list="false"
            :on-success="importSuccess"
            ><el-button type="primary" size="small">导入考试信息 </el-button>
          </el-upload>
        </el-form-item>
        <!-- getPdf() -->
      </el-form>
    </div>
    <div
      id="htmlToPdf"
      style="padding: 20px 25px 50px 25px"
      v-if="!pageRefresh"
    >
      <h1 style="margin: 30px auto" v-if="examinationId">
        {{ examList.find((item) => item.id == examinationId).examName }}
      </h1>

      <div
        v-for="item in chartNameList"
        :key="item"
        class="chartContainer"
        style="padding-top: 20px; height: 550px"
      >
        <div
          style="width: 95%; display: block; height: 400px; margin: auto"
          :id="item"
        ></div>

        <div class="tips" style="font-size: 16px; width: 600px; margin: auto">
          {{ chartData[item].optionRemark }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import {
  studentRadarInfo,
  detailedAnalysisByRegion,
  getExamList,
} from "@/api/index.js";
export default {
  data() {
    return {
      chartData: {},
      chartNameList: [],
      areaChartNameList: [],
      examinationId: "",
      idCard: "",
      areaTableOption: [],
      examList: [],
      areaPrintReady: false,
      normalPrintReady: false,
      ifPrint: true,
      pageRefresh: false,
      turnoverRateAndTime: {},
      doubleAreaOptionList: [],
    };
  },
  methods: {
    getPdf() {
      var title =
        this.examList.find((item) => item.id == this.examinationId).examName +
        "考试分析";
      html2Canvas(document.getElementById("htmlToPdf"), {
        allowTaint: true,
      }).then(function (canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 592.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        setTimeout(() => {
          PDF.save(title + ".pdf");
        }, 1000);
      });
    },
    downloadModel() {
      location.href = "../个人能力图谱分析模板.xlsx";
    },
    importSuccess(data) {
      this.$message.success(data.info);
    },
    printPage() {
      this.ifPrint = false;
      // 获取画布的对象(canvas)
      this.chartNameList.forEach((item) => {
        var mycanvas = document
          .getElementById(item)
          .getElementsByTagName("canvas")[0];
        if (mycanvas) {
          var parent = mycanvas.parentElement;

          var image = mycanvas.toDataURL("image/png");
          var img = document.createElement("img");
          img.src = image;
          img.width = mycanvas.width;
          img.height = mycanvas.height;
          parent.appendChild(img);
          parent.removeChild(mycanvas);
          // 开始打印
          // $("#centerdiv").print();
          // 回复画布的内容
          // parent.appendChild(mycanvas);
          // 将生成的图片内容从到画布所在父元素的内容里删除
          // parent.removeChild(img);
        }
      });
      this.areaChartNameList.forEach((item) => {
        let mycanvas = document
          .getElementById(item)
          .getElementsByTagName("canvas")[0];
        if (mycanvas) {
          let parent = mycanvas.parentElement;

          let image = mycanvas.toDataURL("image/png");
          let img = document.createElement("img");
          img.src = image;
          img.width = mycanvas.width;
          img.height = mycanvas.height;
          parent.appendChild(img);
          parent.removeChild(mycanvas);
        }
      });
      setTimeout(() => {
        var oldstr = document.body.innerHTML;
        var headStr = "<html><head><title></title></head><body>";
        var footStr = "</body>";
        var content = document.getElementById("chartPage").innerHTML;
        var newStr = headStr + content + footStr;
        document.body.style.overflow = "auto";
        // document.body.innerHTML = content;
        let myWindow = window.open();
        myWindow.document.write(content);
        myWindow.print();
        // setTimeout(() => {
        //   window.print();
        // }, 3000);

        // document.body.innerHTML = oldstr;
      }, 1000);
    },
    getData() {
      this.pageRefresh = true;
      setTimeout(() => {
        this.pageRefresh = false;
      }, 500);

      studentRadarInfo({
        examinationId: this.examinationId,
        idCard: this.idCard,
      }).then((data) => {
        this.chartNameList = [];
        for (let i in data.data) {
          // 只有用于制作图标的数据是字符串
          if (typeof data.data[i] == "string") {
            this.chartNameList.push(i);
            this.chartData[i] = JSON.parse(data.data[i]);
          } else {
            if (Array.isArray(data.data[i])) {
              data.data[i].forEach((item) => {
                this.chartNameList.push(item.title.text);
                this.chartData[item.title.text] = item;
              });
            } else {
              this.chartNameList.push(i);
              this.chartData[i] = data.data[i];
            }
          }
        }
        // console.log(this.chartNameList);
        // this.chartNameList.sort();
        // this.examBaseInfo = data.data.examBaseInfo;
        // this.turnoverRateAndTime = data.data.turnoverRateAndTime;
        // this.areaTableOption = data.data.areaOption;
        setTimeout(() => {
          this.chartInit();
        }, 1000);

        // let chart = echarts.init(document.getElementById("myChart"));
        // chart.setOption(JSON.parse(data.data.ageRateOption));
      });
    },
    chartInit() {
      this.chartNameList.forEach((item) => {
        if (Array.isArray(this.chartData[item])) {
        } else {
          let chart = echarts.init(document.getElementById(item));

          chart.setOption(this.chartData[item]);
        }
      });
      this.normalPrintReady = true;
    },
  },
  mounted() {
    getExamList().then((data) => {
      this.examList = data.data;
    });
  },
};
</script>

<style scoped lang="less"  media="print">
.wrapper {
  padding-top: 30px;
  width: 810px;
  margin: auto;
  .chartContainer {
    margin-bottom: 30px;
  }
  .areaChartListContainer {
    .areaCell {
      margin: 20px auto;
    }
  }
}
</style>
